export default __webpack_public_path__ + "static/media/02title.29ba1c45.jpg";